import React from 'react';
import styled from 'styled-components';
import {Default,Mobile,PlayQuizSize} from '../Sizes';

const style = {
	Wrapper : styled.div`
        width : ${PlayQuizSize.Width};
        min-height : ${PlayQuizSize.Height};
		background-color : transparent;
	`,
	mobile : {
		Wrapper : styled.div`
			width : 100%;
			background-color : transparent;
        `,
	}
};



export default function SearchContentLayout({renderContent,...props}){
	return (
		<React.Fragment>
			<Default>
				<style.Wrapper {...props}>
					{renderContent()}
				</style.Wrapper>
			</Default>
			<Mobile>
				<style.mobile.Wrapper {...props}>
					{renderContent()}
				</style.mobile.Wrapper>
			</Mobile>
		</React.Fragment>
		
	);
}
